import Tour from '@core/components/Tour';
import { useApiUtils } from '@core/util/apiUtils';
import { downloadFile } from '@core/util/downloadUtils';
import { mockTourContaReceber } from '@core/util/mockTourUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { useDebounce } from '@fuse/hooks';
import { confirmarAlert, excluirAlert, simpleAlert } from 'app/services/alerts';
import boletoApi from 'app/services/api/boletoApi';
import contaReceberApi from 'app/services/api/contaReceberApi';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext/GlobalContext';
import { eventReactGA, initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import ArquivoRetornoModal from '../arquivoretorno/ArquivoRetornoModal';
import { HistoricoRemessaModal } from '../historicoremessa';
import { ContaReceberTable } from './components';
import ContaReceberSearchHeader from './components/ContaReceberSearchHeader';
import {
  ContaReceberCadastroModal,
  ContaReceberErrosPartnerBankModal,
  ContaReceberVisualizacaoModal,
  ContasReceberBuscaAvancadaModal,
} from './components/modal';
import ContaReceberGraficosModal from './components/modal/ContaReceberGraficosModal';
import ContaReceberPendenciasModal from './components/modal/ContaReceberPendenciasModal';
import ContasReceberRecorrenciaModal from './components/modal/ContaReceberRecorrenciaModal';
import ContasReceberBaixaModal from './components/modal/ContasReceberBaixaModal';
import ResgatarContaReceberContratoModal from './components/modal/ResgatarContaReceberContratoModal';
import { contaReceberModais } from './components/modal/contaReceberModais';
import ImportarContaReceberModal from './components/modal/importarContaReceberModal';
import { ContaReceberSteps } from './components/steps/ContaReceberSteps';
import { ContaReceberContext, ContaReceberProvider } from './contaReceberContext';
import { ContaReceberRecorrenciaProvider } from './contaReceberRecorrenciaContext';
import { ContasReceberUtil } from './contaReceberUtils';
import { ResgatarContaReceberContratoProvider } from './resgatarContaReceberContratoContext';

const CONTA_RECEBER = 'Conta a receber';

const ContasReceber = () => {
  const [, setLoading] = useContext(ContaReceberContext).loading;
  const [, setTotalElements] = useContext(ContaReceberContext).totalElements;
  const [, setContasReceber] = useContext(ContaReceberContext).contasReceber;
  const [, setContaReceberAtual] = useContext(ContaReceberContext).contaReceberAtual;
  const [somatorios, setSomatorios] = useContext(ContaReceberContext).somatorios;
  const [selecao, setSelecao] = useContext(ContaReceberContext).selecao;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [tipoSelecao, setTipoSelecao] = useContext(ContaReceberContext).tipoSelecao;
  const [search] = useContext(ContaReceberContext).search;
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [page, setPage] = useContext(ContaReceberContext).page;
  const [size, setSize] = useContext(ContaReceberContext).size;
  const [existemBoletosPendentes, setExistemBoletosPendentes] = useContext(ContaReceberContext).existemBoletosPendentes;
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  const [run, setRun] = useState(false);
  const [onTour, setOnTour] = useState(false);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);
  const history = useHistory();

  const resetSelecao = () => {
    setSelecao([]);
    setTipoSelecao('NENHUM');
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const initialPage = {
    page: 0,
    q: '',
    size: 15,
    sort: 'dataVencimento,DESC',
    filtroAvancado,
  };

  const situacoesDiferenteMsg = () => {
    apiUtils.handleApiError({
      response: {
        data: {
          message: 'Não é possível realizar nenhuma ação para contas a receber com situações diferentes.',
        },
      },
    });
  };

  const selecionarAoMenosUmaContaParcialMsg = () => {
    apiUtils.handleApiError({
      response: {
        data: {
          message: 'Não é possível selecionar mais de uma conta a receber quando há uma baixa parcial.',
        },
      },
    });
  };

  const fetchSomatorio = useDebounce(async (search = { ids: [], query: '', tipoSelecao: 'NENHUM', filtroAvancado }) => {
    if (search.selecao) {
      search.tipoSelecao = search.selecao;
      delete search.selecao;
    }
    const res = await contaReceberApi.somatorio(search);

    setSomatorios(res.data);
  });

  const carregarDadosMock = () => {
    setContasReceber(mockTourContaReceber);
    setSelecao([]);
    setPage(1);
    setSize(mockTourContaReceber.length);
    setTotalElements([]);
  };

  const buscarTour = async () => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((f) => f === 'CONTAS_RECEBER');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setOnTour(true);
      carregarDadosMock();
    } else {
      fetchContasReceber();
    }
  };

  const formatarFiltroAvancado = (filtro) => {
    return {
      ...filtro,
      dataVencimentoInicio: filtro?.dataVencimentoInicio
        ? filtro?.dataVencimentoInicio?.format('YYYY-MM-DD')
        : undefined,
      dataVencimentoFim: filtro?.dataVencimentoFim ? filtro?.dataVencimentoFim?.format('YYYY-MM-DD') : undefined,
      dataRecebimentoInicio: filtro?.dataRecebimentoInicio
        ? filtro?.dataRecebimentoInicio?.format('YYYY-MM-DD')
        : undefined,
      dataRecebimentoFim: filtro?.dataRecebimentoFim ? filtro?.dataRecebimentoFim?.format('YYYY-MM-DD') : undefined,
      dataLiquidacaoInicio: filtro?.dataLiquidacaoInicio
        ? filtro?.dataLiquidacaoInicio?.format('YYYY-MM-DD')
        : undefined,
      dataLiquidacaoFim: filtro?.dataLiquidacaoFim ? filtro?.dataLiquidacaoFim?.format('YYYY-MM-DD') : undefined,
      dataEmissaoInicio: filtro?.dataEmissaoInicio ? filtro?.dataEmissaoInicio?.format('YYYY-MM-DD') : undefined,
      dataEmissaoFim: filtro?.dataEmissaoFim ? filtro?.dataEmissaoFim?.format('YYYY-MM-DD') : undefined,
      clienteId: filtro?.cliente?.id,
      categoriaId: filtro?.categoria?.id,
      contaId: filtro?.conta?.id,
    };
  };

  const fetchContasReceber = async (search = initialPage) => {
    setLoading(true);
    try {
      if (!search?.filtroAvancado) {
        search.filtroAvancado = formatarFiltroAvancado(filtroAvancado);
      } else {
        search.filtroAvancado = formatarFiltroAvancado(search.filtroAvancado);
      }

      delete search.filtroAvancado.cliente;
      delete search.filtroAvancado.categoria;
      delete search.filtroAvancado.conta;

      const response = await contaReceberApi.buscar(search);

      setPage(response.data.number);
      setSize(response.data.size);
      setTotalElements(response.data.totalElements);

      setContasReceber(response.data.content);

      fetchSomatorio({ tipoSelecao: 'NENHUM', ids: [], ...search });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchContaReceber = async (id) => {
    setLoading(true);
    try {
      const response = await contaReceberApi.buscarPorId(id);

      const contaReceber = response?.data;

      for (let i = 0; i < contaReceber?.baixas?.length; i++) {
        const baixa = contaReceber?.baixas[i];
        if (baixa?.juros || baixa?.multa || baixa?.desconto || baixa?.correcaoMonetaria) {
          baixa.acrescimoDesconto = true;
        }
      }

      let historico = [];
      try {
        const responseHistorico = await contaReceberApi.buscarHistorico(id);
        historico = responseHistorico?.data || [];
      } catch (error) {
        historico = [];
      }

      setContaReceberAtual({ ...contaReceber, historico });
    } catch (err) {
      console.error(err);
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (conta, pageable) => {
    setLoading(true);

    try {
      let res;
      if (conta.id) {
        eventReactGA(CONTA_RECEBER, 'Atualizar conta a receber');
        res = await contaReceberApi.atualizar(conta.id, conta);
        showSuccess('Conta a receber editada com sucesso.');
      } else {
        eventReactGA(CONTA_RECEBER, 'Cadastrar conta a receber');
        res = await contaReceberApi.cadastrar(conta);
        showSuccess('Conta a receber salva com sucesso.');
      }

      resetSelecao();
      fetchContasReceber(pageable);
      setLoading(false);

      return res.data;
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }

    return false;
  };

  const handleSubmitBaixa = async (values, pageable) => {
    setLoading(true);
    try {
      if (values?.multiplo) {
        const request = values?.ids?.map((contaReceber) => ({
          receitaId: contaReceber.id,
          baixas: [
            {
              dataRecebimento: values?.baixa?.dataRecebimento,
              contaId: values?.baixa?.conta?.id,
              formaRecebimento: values?.baixa?.formaRecebimento,
              valorRecebido: contaReceber.valor,
              dataLiquidacao: values?.baixa?.dataLiquidacao,
            },
          ],
        }));
        await contaReceberApi.baixar(request);
      } else {
        const request = values.ids.map((contaReceber) => ({
          // quando é multiplo, a listagem vem com o objeto contaReceber, ao invés do id
          receitaId: contaReceber?.id ? contaReceber?.id : contaReceber,
          baixas: [
            {
              dataRecebimento: values?.baixa?.dataRecebimento,
              dataRecebimentoInicio: values?.baixa?.dataRecebimentoInicio,
              dataRecebimentoFim: values?.baixa?.dataRecebimentoFim,
              contaId: values?.baixa?.conta?.id,
              juros: values?.baixa?.juros,
              multa: values?.baixa?.multa,
              correcaoMonetaria: values?.baixa?.correcaoMonetaria,
              desconto: values?.baixa?.desconto,
              formaRecebimento: values?.baixa?.formaRecebimento,
              valorRecebido: values?.baixa?.valorRecebido,
              dataLiquidacao: values?.baixa?.dataLiquidacao,
              dataLiquidacaoInicio: values?.baixa?.dataLiquidacaoInicio,
              dataLiquidacaoFim: values?.baixa?.dataLiquidacaoFim,
            },
          ],
        }));
        await contaReceberApi.baixar(request);
      }

      eventReactGA(CONTA_RECEBER, 'Baixar');
      resetSelecao();
      fetchContasReceber(pageable);

      showSuccess('Conta a receber baixada com sucesso.');

      setLoading(true);
      return true;
    } catch (err) {
      apiUtils.handleApiError(err);
      setLoading(false);
      return false;
    }
  };

  const cancelarBaixas = async ({ selecao, tipoSelecao, params: { q }, gerarNovasCobrancas = false }, pageable) => {
    try {
      setLoading(true);

      eventReactGA(CONTA_RECEBER, 'Cancelar baixa');

      const ids = selecao?.map((conta) => conta?.id);

      await contaReceberApi.cancelarBaixas({
        ids,
        q,
        tipoSelecao,
        gerarNovasCobrancas,
        filtroAvancado,
      });

      const temContasOrigensDistintas = ContasReceberUtil.verificarContasOrigensDistintas(selecao);

      const baixaConciliada = ContasReceberUtil.verificarBaixaConciliada(selecao);

      const todasOrigemConciliacao = ContasReceberUtil.verificarTodasContasOrigemConciliacao(selecao);

      const quantidadeContas = selecao?.length || 0;

      const mensagem = todasOrigemConciliacao
        ? 'O cancelamento da baixa foi realizado e a conta foi excluída com sucesso.'
        : baixaConciliada && !temContasOrigensDistintas
        ? 'Desconciliação realizada com sucesso.'
        : quantidadeContas === 1
        ? 'Baixa cancelada com sucesso.'
        : 'Baixa(s) cancelada(s) com sucesso.';

      showSuccess(mensagem);

      resetSelecao();
      setModal('');
      fetchContasReceber(pageable);
    } catch (error) {
      apiUtils.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleModalBaixar = (selecao) => {
    if (ContasReceberUtil.verificarPodeBaixar(selecao)) {
      setModal(contaReceberModais.baixarContaReceber);
      if (selecao?.length === 1) {
        fetchContaReceber(selecao[0].id);
        setModal(contaReceberModais.baixarContaReceber);
      } else {
        setModal(contaReceberModais.baixarContaReceber);
      }
    } else if (selecao?.length > 1 && selecao?.every((cp) => cp.situacao === 'PARCIAL')) {
      selecionarAoMenosUmaContaParcialMsg();
    } else {
      situacoesDiferenteMsg();
    }
  };

  const handleCancelarBaixa = async ({ selecao, tipoSelecao, params: { q } }, pageable) => {
    if (!ContasReceberUtil.verificarPodeCancelarBaixa(selecao)) {
      situacoesDiferenteMsg();
    } else if (ContasReceberUtil.verificarBaixaConciliada(selecao)) {
      const temContasOrigensDistintas = ContasReceberUtil.verificarContasOrigensDistintas(selecao);
      const todasOrigemConciliacao = ContasReceberUtil.verificarTodasContasOrigemConciliacao(selecao);
      const titulo = temContasOrigensDistintas
        ? 'Há contas selecionadas de origens distintas. As contas originadas pela conciliação bancária serão excluídas. Deseja continuar?'
        : todasOrigemConciliacao
        ? 'Essa conta será desconciliada e excluída, pois foi originada na conciliação bancária. Deseja continuar?'
        : 'Essa conta será desconciliada e a baixa cancelada. Deseja continuar?';

      confirmarAlert({
        titulo,
        confirmar: () => {
          setLoading(true);
          cancelarBaixas({ selecao, tipoSelecao, params: { q } }, pageable);
        },
      });
    } else {
      confirmarAlert({
        opcoes: {
          title: 'Tem certeza que deseja cancelar a(s) baixa(s)?',
        },
        confirmar: () => {
          setLoading(true);

          const gerarNovasCobrancas =
            (tipoSelecao === 'TODOS_FILTRO' &&
              (somatorios?.quantidadeSelecionadasRemessaPendente > 0 ||
                somatorios?.quantidadeSelecionadasRemessaGeradaOuAceita > 0)) ||
            selecao?.some(
              (contaReceber) =>
                contaReceber.situacaoRemessa === 'PENDENTE' ||
                contaReceber.situacaoRemessa === 'GERADA' ||
                contaReceber.situacaoRemessa === 'ACEITA'
            );

          // RNE-318
          if (gerarNovasCobrancas) {
            setLoading(false);

            confirmarAlert({
              opcoes: {
                title: 'Existem contas selecionadas que não estão registradas no banco. Deseja registrá-las?',
              },
              confirmar: () => {
                setLoading(true);

                cancelarBaixas({ selecao, tipoSelecao, params: { q }, gerarNovasCobrancas: true }, pageable);
              },
              cancelar: () => {
                setLoading(true);
                cancelarBaixas({ selecao, tipoSelecao, params: { q } }, pageable);
              },
            });
          } else {
            setLoading(true);
            cancelarBaixas({ selecao, tipoSelecao, params: { q } }, pageable);
          }
        },
      });
    }
  };

  const handleDelete = async (filtro, pageable) => {
    let isSelecaoValida = true;

    if (filtro?.tipoSelecao === 'TODOS_FILTRO') {
      isSelecaoValida = somatorios?.quantidadeSelecionadasOrigemContratoVenda === 0;
    } else {
      isSelecaoValida = !filtro?.ids?.some((c) => {
        return (
          c.origemLancamento === 'CONTRATO' || c.origemLancamento === 'VENDA' || c.origemLancamento === 'VENDA_CONTRATO'
        );
      });
    }

    if (!ContasReceberUtil.verificarPodeExcluir(filtro.ids)) {
      situacoesDiferenteMsg();
    } else if (!isSelecaoValida) {
      apiUtils.handleApiError({
        response: {
          data: {
            message: 'Cobranças originadas de contratos ou vendas só podem ser excluídas na funcionalidade de origem.',
          },
        },
      });
    } else {
      excluirAlert({
        opcoes: {
          title: 'Você realmente deseja excluir?',
          text: '',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        },
        confirmar: async () => {
          try {
            eventReactGA(CONTA_RECEBER, 'Excluir conta a receber');
            await contaReceberApi.excluir({ ...filtro, filtroAvancado, ids: filtro.ids.map((c) => c.id) });
            showSuccess(filtro.ids.length === 1 ? 'Conta excluída com sucesso' : 'Contas excluídas com sucesso');
            resetSelecao();
            fetchContasReceber(pageable);
          } catch (err) {
            apiUtils.handleApiError(err);
          }
        },
      });
    }
  };

  const handleEnviarCobrancasEmail = async (request) => {
    if (selecao?.length === 0 && tipoSelecao !== 'TODOS_FILTRO') {
      apiUtils.handleApiError({
        response: {
          data: {
            message: 'É necessário selecionar um registro para concluir a ação.',
          },
        },
      });
    } else {
      confirmarAlert({
        opcoes: {
          title: 'Tem certeza que deseja enviar as cobranças selecionadas por e-mail?',
        },
        confirmar: async () => {
          try {
            eventReactGA(CONTA_RECEBER, 'Enviar cobranças por e-mail');
            await contaReceberApi.enviarCobrancasEmail(request);
            showSuccess('As cobranças estão sendo enviadas para os destinatários que possuem e-mail.');
          } catch (err) {
            apiUtils.handleApiError(err);
          }
        },
      });
    }
  };

  const validarSelecaoCobrancasRemessa = () => {
    if (
      somatorios?.quantidadeSelecionadasRemessaGeradaOuAceita > 0 &&
      somatorios?.quantidadeSelecionadasRemessaGeradaOuAceita === somatorios?.quantidadeSelecionadas
    ) {
      return {
        response: {
          data: { message: 'As contas selecionadas não estão pendentes de geração de remessa.' },
        },
      };
    }
  };

  const handleGerarRemessa = async () => {
    setLoading(true);
    const error = validarSelecaoCobrancasRemessa();

    if (error) {
      setLoading(false);
      apiUtils.handleApiError(error);
    } else {
      const filtro = {
        ...filtroAvancado,
        ids: selecao?.map((conta) => conta?.id),
        q: search,
        tipoSelecao,
      };

      const downloadRemessa = async () => {
        try {
          setLoading(true);
          eventReactGA(CONTA_RECEBER, 'Gerar remessa dos boletos');
          const response = await boletoApi.gerarRemessa(filtro);
          downloadFile(response.data.remessa, 'Remessas.zip');
          fetchContasReceber();
        } catch (err) {
          apiUtils.handleApiError(err);
        } finally {
          setLoading(false);
        }
      };

      const semRegistroSelecionado = (!selecao || selecao.length === 0) && tipoSelecao !== 'TODOS_FILTRO';

      let possuiAbertasSelecioandas;
      if (tipoSelecao === 'TODOS_FILTRO') {
        possuiAbertasSelecioandas = !!somatorios.quantidadeAbertas;
      } else {
        possuiAbertasSelecioandas = ContasReceberUtil.possuiAbertasSelecioandas(selecao);
      }

      setLoading(false);
      if (!semRegistroSelecionado && possuiAbertasSelecioandas) {
        confirmarAlert({
          opcoes: {
            title: 'Você deseja realmente gerar o arquivo remessa das contas abertas selecionadas?',
            text:
              'Caso existam contas alteradas ou baixadas manualmente após registro no banco, elas serão enviadas automaticamente nessa remessa.',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
          },
          confirmar: async () => {
            downloadRemessa(selecao);
          },
        });
      } else if (existemBoletosPendentes) {
        confirmarAlert({
          opcoes: {
            title:
              'Nenhuma conta aberta foi selecionada para envio da remessa, mas existem contas alteradas e/ou baixadas manualmente que precisam ser reenviadas. Você deseja gerar arquivo remessa com essas contas?',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
          },
          confirmar: async () => {
            downloadRemessa([]);
          },
        });
      } else {
        simpleAlert({
          opcoes: {
            title:
              'Não existem contas alteradas e/ou baixadas manualmente para envio ao banco. Selecione as contas abertas desejadas para geração do arquivo remessa.',
          },
        });
      }
    }
  };

  const handleReenviarBoletoPartnerBank = async (id) => {
    try {
      confirmarAlert({
        opcoes: {
          title: 'Tem certeza que deseja reenviar a cobrança?',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        },
        confirmar: async () => {
          setLoading(true);

          eventReactGA(CONTA_RECEBER, 'Reenviar cobrança do Partner Bank');
          await boletoApi.reenviarBoleto(id);

          setLoading(false);

          showSuccess('Cobrança reenviada ao Partner Bank com sucesso.');

          fetchContasReceber({ page, q: search, size, filtroAvancado });
        },
      });
    } catch (err) {
      setLoading(false);

      apiUtils.handleApiError(err);
    }
  };

  // Verificar se existem algum boleto pendente para geração da remessa
  const verificarBoletosRemessaPendente = async () => {
    const resp = await boletoApi.existemBoletosRemessaPendente();
    setExistemBoletosPendentes(resp.data);
  };

  const onInit = () => {
    initializeReactGA(history?.location?.pathname);
    // fetchContasReceber();
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    buscarTour();
    verificarBoletosRemessaPendente();
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('CONTAS_RECEBER');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setOnTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      fetchContasReceber();
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(onInit, []);

  return (
    <FusePageCarded
      innerScroll
      header={
        <ContaReceberSearchHeader
          onGerarRemessa={handleGerarRemessa}
          onEnviarCobrancasEmail={handleEnviarCobrancasEmail}
        />
      }
      content={
        <>
          <Tour
            steps={ContaReceberSteps}
            run={run}
            setRun={setRun}
            disableScrolling={true}
            onFinish={() => atualizarTour()}
          />

          <ContaReceberTable
            onDelete={handleDelete}
            fetchContas={fetchContasReceber}
            fetchConta={fetchContaReceber}
            onSelecaoChange={setSelecao}
            onTipoSelecaoChange={setTipoSelecao}
            onCancelarBaixa={handleCancelarBaixa}
            handleModalBaixar={handleModalBaixar}
            onReenviarBoletoPartnerBank={handleReenviarBoletoPartnerBank}
            onTour={onTour}
          />
          <ContaReceberCadastroModal onSubmit={handleSubmit} />
          <ContasReceberBaixaModal onSubmit={handleSubmitBaixa} />
          <ContasReceberRecorrenciaModal fetchContasReceber={fetchContasReceber} showSuccess={showSuccess} />
          <ResgatarContaReceberContratoModal fetchContasReceber={fetchContasReceber} />
          <ContaReceberVisualizacaoModal onCancelarBaixa={handleCancelarBaixa} />
          <ContasReceberBuscaAvancadaModal fetchContasReceber={fetchContasReceber} />
          <HistoricoRemessaModal
            openModal={modal === contaReceberModais.historicoRemessa}
            onCloseModal={() => setModal('')}
          />
          <ArquivoRetornoModal
            openModal={modal === contaReceberModais.arquivoRetorno}
            onCloseModal={() => {
              setModal('');

              fetchContasReceber({ page, q: search, size, filtroAvancado });
            }}
          />
          <ContaReceberErrosPartnerBankModal
            openModal={modal === contaReceberModais.errosPartnerBank}
            onCloseModal={() => setModal('')}
          />
          <ContaReceberPendenciasModal />
          <ContaReceberGraficosModal />
          <ImportarContaReceberModal fetchContasReceber={fetchContasReceber} />
        </>
      }
    />
  );
};

const ContaReceberContainer = () => (
  <ResgatarContaReceberContratoProvider>
    <ContaReceberRecorrenciaProvider>
      <ContaReceberProvider>
        <ContasReceber />
      </ContaReceberProvider>
    </ContaReceberRecorrenciaProvider>
  </ResgatarContaReceberContratoProvider>
);

export default ContaReceberContainer;
